(function () {
    'use strict';

    angular
        .module('app')
        .component('tourCreate', {
            templateUrl: 'components/directives/tour_create/view.tour_create.html',
            bindings: {
                upcomingConcerts: '<',
                concert: '<',
                tour: '<',
                onClose: '&',
                onSave: '&'
            },
            controller: ['$scope', '$http', '$q', '$log', 'tourHelper', TourCreateController]
        });


    function TourCreateController($scope, $http, $q, $log, tourHelper) {
        const ctrl = this;
        ctrl.isSaving = false;
        ctrl.isEdit = false;

        // A list of concerts along with a setting that determines if they are
        // selected and/or selectable
        ctrl.concerts = [];

        ctrl.$onInit = function () {
            // Set up the initial tour model, including a concert list toggle
            // with the given concert, if we're creating a tour
            const concertList = [];

            if (ctrl.concert) {
                concertList.push({
                    ...angular.copy(ctrl.concert),
                    selected: true,
                    selectable: false,
                });
            }

            if (ctrl.tour) {
                ctrl.isEdit = true;
                concertList.push(
                    ...ctrl.tour.concerts.map(concert => ({
                        ...angular.copy(concert),
                        selected: true,
                        selectable: true,
                    }))
                );
                ctrl.tour = {
                    ...angular.copy(ctrl.tour)
                }
                delete ctrl.tour.concerts;
            } else  {
                const tour = {
                    band_id: ctrl.concert.band_id,
                    name: '',
                };
                ctrl.tour = tour;
            }

            ctrl.concerts = concertList;

            loadUpcomingConcerts();
        }

        ctrl.close = function () {
            ctrl.onClose();
        };

        ctrl.save = async function () {
            try {
                ctrl.isSaving = true;
                ctrl.tour.concert_ids = ctrl.concerts
                    .filter(setting => setting.selected)
                    .map(setting => Number(setting.concert_id));

                if (ctrl.isEdit) {
                    await $q.when($http.put('api/users/private/tours/' + ctrl.tour.id, ctrl.tour));
                } else {
                    await $q.when($http.post('api/users/private/tours', ctrl.tour));
                }
                ctrl.onSave();
            } finally {
                ctrl.isSaving = false;
            }
        };

        ctrl.toggleConcert = function () {
            $scope.$applyAsync(() => {
                updateConcertSetting()
            });
        };

        async function loadUpcomingConcerts() {
            let upcomingConcerts = ctrl.upcomingConcerts;

            // If given by the component properties, don't make an API call.
            if (!upcomingConcerts) {
                const response = await $q.when($http.get('api/users/private/upcoming_concerts'));
                upcomingConcerts = response.data.upcoming_concerts;
            }

            // Concerts are valid if they are not rejected, not draft, not already part of
            // a tour and not the initial concert that was clicked on.
            upcomingConcerts = upcomingConcerts.filter(concert =>
                concert.concert_published
                && !concert.concert_rejected
                && !concert.concert_pending
                && !concert.tour_id
                && !ctrl.concerts.some(c => c.concert_id === concert.concert_id)
            )

            // Load upcoming concerts and set
            $scope.$applyAsync(() => {
                ctrl.concerts = [
                    ...ctrl.concerts,
                    ...upcomingConcerts.map(concert => ({
                        ...concert,
                        selected: false,
                        selectable: false
                    }))
                ]
                updateConcertSetting();
            });
        }

        function updateConcertSetting() {
            $log.debug('Concerts selected before', ctrl.concerts.map(c => c.selected));

            const selectedTour = {
                concerts: ctrl.concerts.filter(concert => concert.selected)
            };

            ctrl.concerts.forEach(concert => {
                concert.selectable = tourHelper.isConcertValidForTour(selectedTour, concert);
            });

            $log.debug('Concerts selected after', ctrl.concerts.map(c => c.selected));
        }
    }
})();